import React, { Component } from "react";
import { Row, Col } from "antd";
import RecurringIcon from "../../../../../../../assets/icons/recurring.svg";
import { SecondaryButtonComponent } from "../../../../../../../CommonComponents/commonStyles";
import {
  LabelDataHeading,
  ValueDataHeading,
  Underlined,
  ContentDivider,
  CharityHeading
} from "../../../style";
import { AlertMessagePrimary } from "../../AlertPopUp/AlertPopUp";
import { connect } from "react-redux";
import { cancelTxnSchedule } from "../../../actions";
import { getPrimaryAccount } from "../../../../../../../utils/sessionUtil";
import formatter from "../../../../../../../utils/formatter";
import Highlighter from "react-highlight-words";
import { withRouter } from "react-router-dom";
import { milliToDate, recordError } from "../../../../../../../utils/commonUtil";
import Contents from "../../../../../../../CommonComponents/ContentMessages";
import { getAlert } from "../../../../../../NPA/Pages/Step1Setup/Components/UtilFunctions";

export const renderAmount = text => {
  if (text !== "--") {
    return formatter({
      value: text,
      fieldSuffix: "Dollars"
    });
  } else {
    return text;
  }
};

class RecurringExchangesCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popup: false,
      id: "",
      search: this.props.search
    };
    this.handlePop = this.handlePop.bind(this);
  }


  cancelSingle() {
    this.setState({ popup: !this.state.popup });
    this.props.cancelTxnSchedule({
      method: "PUT",
      page: "grantsActivity",
      url: `/donor-portal/api/grant/${getPrimaryAccount().userId}/cancelGrant`,
      data: {
        accountId: getPrimaryAccount().userId,
        scheduleId: this.props.data.scheduleId,
        grantType: "recurring"
      }
    });
  }


  handlePop(id) {
    this.setState({ popup: !this.state.popup, id });
  }

  viewGrants = (id, type) => {
    try {
      if (type === "single") {
        this.props.history.push(`/grants/activity/view?grantId=${id}`);
      } else {
        this.props.history.push(`/grants/activity/view?scheduleId=${id}`);
      }
    } catch (error) {
      recordError(error);
    }
  };



  componentDidUpdate(prev) {
    if (prev.search != this.state.search) {
      this.setState({ search: this.props.search });
    }
  }


  render() {
    const { data, index } = this.props;
    let enteredDate = milliToDate(data.enteredDate);
    let nextScheduledDate = milliToDate(data.nextScheduledDate);  
    return (
      <div  data-test = "consumer">
        <Contents.Consumer>
          {props => {
            let gaAlerts = props.alert_messages['Grant Activity'] ? props.alert_messages['Grant Activity'] : [];
            let obj = gaAlerts.length ? getAlert(gaAlerts,'Exchange') : [];
            return (
              <AlertMessagePrimary 
              title={(obj.length && obj[0].field_header)||"Cancel"}
              visible={this.state.popup}
              onCancel={() => this.handlePop()}
              onOk={() => this.cancelSingle()}
              width={460}
              cancelText={( obj.length && obj[0].field_alert_button2_text ) || "No, take me back"}
              okText={( obj.length && obj[0].field_alert_button1_text ) || "CONTINUE"}
            >
              {(obj.length && <span dangerouslySetInnerHTML={{__html:obj[0].field_description}} />) || "Are you sure you want to cancel this exchange schedule? Selecting Yes will cancel the exchange schedule and delete all optional information entered for all the upcoming spawns."}
            </AlertMessagePrimary>
            )
          }}
        </Contents.Consumer>
        <Row>
          <Col span={20}>
            <CharityHeading>
              {data.granteeOrg ? (
                <Highlighter
                  id={`recurring-hightlighter-${index}`}
                  highlightStyle={{
                    color: "black",
                    fontWeight: 600,
                    backgroundColor: "transparent"
                  }}
                  searchWords={[this.props.search]}
                  autoEscape={true}
                  textToHighlight={data.granteeOrg.legalName && data.granteeOrg.legalName.toString()}
                />
              ) : (
                <>&mdash;</>
              )}
            </CharityHeading>
          </Col>
          <Col span={4}>
            <ValueDataHeading>
              {data.isRecurring == true ? <img src={RecurringIcon} alt = "RecurringIcon"/> : null}
            </ValueDataHeading>
          </Col>
        </Row>
        <ContentDivider />
        <Row>
          <Col span={12}>
            <LabelDataHeading>Entered Date</LabelDataHeading>
            <ValueDataHeading>
              {enteredDate === "Invalid date" ? (
                <div>&mdash;</div>
              ) : (
                enteredDate
              )}
            </ValueDataHeading>
          </Col>
          <Col span={12}>
            <LabelDataHeading>Amount</LabelDataHeading>
            <ValueDataHeading>
              {renderAmount(data.grantAmount)}
            </ValueDataHeading>
          </Col>
        </Row>
        <ContentDivider />
        <Row>
          <Col span={12}>
            <LabelDataHeading>Next Scheduled</LabelDataHeading>
            <ValueDataHeading>
              {nextScheduledDate === "Invalid date" ? (
                <div>&mdash;</div>
              ) : (
                nextScheduledDate
              )}
            </ValueDataHeading>
          </Col>
          <Col span={12}>
            <LabelDataHeading>Remaining Payments</LabelDataHeading>
            <ValueDataHeading>{data.remainingPayments}</ValueDataHeading>
          </Col>
        </Row>
        <ContentDivider />
        <Row>
          <Col span={12}>
            <LabelDataHeading>Frequency</LabelDataHeading>
            <ValueDataHeading>{data.frequency}</ValueDataHeading>
          </Col>

          <Col span={12}>
            <LabelDataHeading>Status</LabelDataHeading>
            <ValueDataHeading>{data.status}</ValueDataHeading>
          </Col>
        </Row>
        <ContentDivider />
        <Row>
          <Col span={8}>
            {data.status === "Active" ||
            (data.status === "Entered" &&
              this.props.user.role.access === "All Access") ? (
              <SecondaryButtonComponent
                onClick={() => this.viewGrants(data.scheduleId, "recurring")}
              >
                View & Edit
              </SecondaryButtonComponent>
            ) : (
              <SecondaryButtonComponent
                onClick={() => this.viewGrants(data.scheduleId, "recurring")}
              >
                View
              </SecondaryButtonComponent>
            )}
          </Col>
          <Col span={8} offset={4}>
            {(data.status == "Active" || data.status == "Entered") &&
            this.props.user.role.access === "All Access" ? (
              <Underlined
                onClick={() => {
                  this.handlePop(data.grantId);
                }}
              >
                {data.status == "Cancelled" ? null : "Cancel"}
              </Underlined>
            ) : null}
          </Col>
        </Row>
      </div>
    );
  }
}

export const mapDispatchToProps = dispatch => ({
  cancelTxnSchedule: data => dispatch(cancelTxnSchedule(data))
});

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(RecurringExchangesCard)
);
